import { render, staticRenderFns } from "./vacation-period-list.component.vue?vue&type=template&id=abb8419c&scoped=true&"
import script from "./vacation-period-list.component.vue?vue&type=script&lang=ts&"
export * from "./vacation-period-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./vacation-period-list.component.vue?vue&type=style&index=0&id=abb8419c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb8419c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
